import template from './home.html';
import controller from './home.controller';
import './home.scss';

let homeComponent = {
  restrict: 'E',
  bindings: {
    confirmTemplateModel: '<'
  },
  template,
  controller
};

export default homeComponent;



// WEBPACK FOOTER //
// ./client/app/components/home/home.component.js